import { SUPPORT_EMAIL_ID } from "../../../utils/helper";

export const docGenerationUpgradeMessages = (t, planName, transactionLimit) =>
  planName === 'Premium'
    ? t(
        TEMPLATE_PREVIEW_MODAL.PREMIUM_PLAN_LIMIT_REACHED_MESSAGE.key,
        TEMPLATE_PREVIEW_MODAL.PREMIUM_PLAN_LIMIT_REACHED_MESSAGE.value,
        { emailId: SUPPORT_EMAIL_ID },
      )
    : planName === 'Free'
    ? t(
        TEMPLATE_PREVIEW_MODAL.FREE_PLAN_LIMIT_REACHED_MESSAGE.key,
        TEMPLATE_PREVIEW_MODAL.FREE_PLAN_LIMIT_REACHED_MESSAGE.value,
        { transactionLimit },
      )
    : t(
        TEMPLATE_PREVIEW_MODAL.STANDARD_PLAN_LIMIT_REACHED_MESSAGE.key,
        TEMPLATE_PREVIEW_MODAL.STANDARD_PLAN_LIMIT_REACHED_MESSAGE.value,
        { transactionLimit },
      );

export const DOCUMENT_TEMPLATES_MENUBAR = {
  RESIZE_DOCUMENT_TOOLTIP: { key: 'RESIZE_DOCUMENT_TOOLTIP', value: 'Resize' },
  DOWNLOAD_DOCUMENT_TOOLTIP: { key: 'DOWNLOAD_DOCUMENT_TOOLTIP', value: 'Download' },
  SAVE_DOCUMENT_TOOLTIP: { key: 'SAVE_DOCUMENT_TOOLTIP', value: 'Save' },
  ZOOM_DESIGN_TOOLTIP: { key: 'ZOOM_DESIGN_TOOLTIP', value: 'Zoom' },
  ZOOM_FIT_DROPDOWN_OPTION: { key: 'ZOOM_FIT_DROPDOWN_OPTION', value: 'Fit' },
  ZOOM_DEFAULT_DROPDOWN_OPTION: { key: 'ZOOM_DEFAULT_DROPDOWN_OPTION', value: 'Default' },
  SET_ZOOM_DEFAULT_TOOLTIP: { key: 'SET_ZOOM_DEFAULT_TOOLTIP', value: 'Set default zoom' },
  DEFAULT_ZOOM_TOOLTIP: { key: 'DEFAULT_ZOOM_TOOLTIP', value: 'Default Zoom' },
  NO_CHANGES_MADE_IN_DESIGN_WARNING_MESSAGE: {
    key: 'NO_CHANGES_MADE_IN_DESIGN_WARNING_MESSAGE',
    value: 'No recent changes made!!',
  },
  PAGES_UPDATED_OR_DELETED_SUCCESS_MESSAGE: {
    key: 'PAGES_UPDATED_OR_DELETED_SUCCESS_MESSAGE',
    value: 'Pages updated/deleted successfully',
  },
  PAGE_UPDATED_SUCCESS_MESSAGE: {
    key: 'PAGE_UPDATED_SUCCESS_MESSAGE',
    value: 'Pages updated successfully',
  },
  TEMPLATE_UPDATED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_UPDATED_SUCCESS_MESSAGE',
    value: 'Template updated successfully',
  },
  EXPORT_DOCUMENT_LABEL: {
    key: 'EXPORT_DOCUMENT_LABEL',
    value: 'Export document',
  },
  IMPORT_DOCUMENT_LABEL: {
    key: 'IMPORT_DOCUMENT_LABEL',
    value: 'Import document',
  },
  DOCUMENT_PRINT_SUCCESS_LABEL: {
    key: 'DOCUMENT_PRINT_SUCCESS_LABEL',
    value: 'Document downloaded successfully',
  },
  DOCUMENT_PRINT_ERROR_LABEL: {
    key: 'DOCUMENT_PRINT_ERROR_LABEL',
    value: 'Unable to download document!!',
  },
  DOCUMENT_EXPORT_ERROR: {
    key: 'DOCUMENT_EXPORT_ERROR',
    value: 'There is an issue with document export. Please try again.',
  },
  DOCUMENT_IMPORT_ERROR: {
    key: 'DOCUMENT_IMPORT_ERROR',
    value: 'There is an issue with document import. Please try again.',
  }
};

export const TEMPLATE_PREVIEW_MODAL = {
  PREVIEW_TOOLTIP: { key: 'PREVIEW_TOOLTIP', value: 'Preview' },
  PREVIEW_DOCUMENT_BUTTON: { key: 'PREVIEW_DOCUMENT_BUTTON', value: 'Preview' },
  PAGE_NUMBER_LABEL: { key: 'PAGE_NUMBER_LABEL', value: 'Page {{PageNum}} of' },
  GENERATING_PREVIEW:{ key: 'GENERATING_PREVIEW', value: 'Generating Preview' },
  ERROR_GENERATING_PREVIEW: { key: 'ERROR_GENERATING_PREVIEW', value: "Error while generating preview"},
  PREVIEW_LOADER_TITLE: { key: 'PREVIEW_LOADER_TITLE', value:'Sit back and relax! Your design preview is coming right up!'},
  PREVIEW_LOADER_MESSAGE: { key: 'PREVIEW_LOADER_MESSAGE', value:'This might take a bit, depending on how complex the design and logic are.'},
  PREMIUM_PLAN_LIMIT_REACHED_MESSAGE: {
    key: 'PREMIUM_PLAN_LIMIT_REACHED_MESSAGE',
    value: "You have reached the limit for generating documents under your current plan. You can either wait until your quota renews next month or upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href='mailto:{{emailId}}'>{{emailId}}</a>." },
  STANDARD_PLAN_LIMIT_REACHED_MESSAGE: {
    key: 'STANDARD_PLAN_LIMIT_REACHED_MESSAGE',
    value: "In the standard plan, you are limited to generating {{transactionLimit}} pages. To generate more, please upgrade your plan." },
  FREE_PLAN_LIMIT_REACHED_MESSAGE: {
    key: 'FREE_PLAN_LIMIT_REACHED_MESSAGE',
    value:'In the free plan, you are limited to generating {{transactionLimit}} pages. To generate more, please upgrade your plan.',
  },
  DOWNLOAD_SAMPLE_FORMAT_BUTTON: {
    key: 'DOWNLOAD_SAMPLE_FORMAT_BUTTON',
    value: 'Download request sample',
  },
  BUlk_UPLOAD_DOCUMENT_BUTTON: {
    key: 'BUlk_UPLOAD_DOCUMENT_BUTTON',
    value: 'Generate Bulk Documents',
  },
  ERROR_WHILE_DOWNLOAD: { key: 'ERROR_WHILE_DOWNLOAD', value: "Error while downloading"},
  ACCESSIBILITY_PREVIEW_BUTTON: { key: 'ACCESSIBILITY_PREVIEW_BUTTON', value: 'Accessibility Preview' },
  ERROR_WHILE_WEBHOOK_TRANSACTION: { key: 'ERROR_WHILE_WEBHOOK_TRANSACTION', value: "Something went wrong. Please try again."}
};
